export enum WindowMessageType {
    LOCATION_CONTEXT = "INSIGHTS_HUB_LOCATION_CONTEXT",
}
